// Copyright (c) 2019 Deere & Company
import '../index.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, {Component} from 'react';
import {createErrorMessage, createSuccessMessage} from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
//import CSVFile from '../../assets/factory_data_extract.csv';
import FileUploadPanel from './file-upload-panel';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {customizeErrorAlert} from '../../shared/services/customize-error-alert-bar';
import {showLoadingIndicator} from '../../shared/state/busy-counter';
import {uploadBatchFactoryData} from '../repositories';
import _ from 'lodash';
import { downloadSampleReports } from '../../claims/repositories';
// import {Accordion} from 'react-bootstrap';

class BatchFactoryDataUpload extends Component {

    state = {
        fileInfo: {},
        uploadResp: {},
        // uploadStatus: '',
        isRefineWorklist: false
    }

    componentDidMount() {

        this.props.increaseCounter();
        setTimeout(() => {
            this.props.decreaseCounter();
        }, 500);

    }

    handleFileDrop = files => {
        console.log("handleFileDrop :", this.state.isChecked);
        this.setState({
            fileInfo: files[0],
        });

    }

    handleRejectedFiles = () => {

        this.props.increaseCounter();
        const msg = 'Only CSV files are allowed';
        customizeErrorAlert(msg);
        this.props.decreaseCounter();

    }

    handleSubmitClick = () => {
        this.setState({
            uploadResp: {},
            // uploadStatus: ''
        });

        let endPoint = "factory-data-upload"
        if (this.state.isRefineWorklist)
            endPoint = "factory-data-upload-worklist"

        this.props.increaseCounter();
        uploadBatchFactoryData(this.state.fileInfo, endPoint).then(response => {
            console.log("response.status::", response.status);
            if (response.errors.length) {
                response.errors.forEach(element => {
                    customizeErrorAlert(element);
                });

            } else {
                // console.log("response.status::", response.uploadStatisticsMap);
                if (response.skipClaims.length) {
                    response.skipClaims.forEach(element => {
                        customizeErrorAlert(element);
                    });
                }
                this.setState({
                    // uploadResp: response.uploadStatistics,
                    uploadResp: response
                    // uploadResp: response.uploadStatisticsMap,
                    // uploadStatus: response.status
                });
                console.log("uploadResp", this.state.uploadResp);
                // this.props.createSuccessMessage( response.status );
            }
            this.props.decreaseCounter();

        }).catch(() => {
            this.props.decreaseCounter();
        });
    }

    handleCancleClick = () => {
        this.setState({
            fileInfo: {},
            uploadResp: {},
            // uploadStatus: '',
        });

    }

    handleCheckBoxClick = e => {
        // console.log("is handleCheckBoxClick ",this.state.isRefineWorklist);

        this.state.isRefineWorklist === false ? this.state.isRefineWorklist = true
            : this.state.isRefineWorklist = false

        // console.log(" isRefineWorklist ",this.state.isRefineWorklist);
    }
handleDownloadClick = (fileName) => () => {
        console.log("fileName", fileName);
        
        this.props.increaseCounter();

        downloadSampleReports(fileName)
            .then(response => {
                response.blob().then( blob => {

                    const url = window.URL.createObjectURL( blob );
                    const a = document.createElement( 'a' );
                    a.setAttribute( 'download', fileName+'.csv' );
                    a.href = url;
                    document.body.appendChild( a );
                    a.click();
                    a.parentNode.removeChild( a );
            
                } );
                this.props.decreaseCounter();
            })
            .catch(() => {
                this.props.decreaseCounter();
            });
    }

    render() {
        const containerStyle = {
            // marginTop: '1%',
            backgroundColor: 'white',
            border: '1px solid black',
            borderStyle: 'dotted',
            borderRadius: '4px',
            paddingLeft: '10px',
            marginLeft: '5px',
            marginRight: '5px',
            fontSize: '14px'
        };

        // const responses = {
        //     'FUNCTION_CD': '2',
        //     'DESIGN_TEAM_CD': '2',
        //     'CORRECT_PART_NUM': '2',
        //     'MFG_DEPT_ID': '2',
        //     'MODEL_YR': '2',
        //     // 'INVALID PRIMEPART NUMBER':"[123,123,234,567,7856]"
        // }
        // const uploadStatus = "TOTAL UPDATED : 100 Out-Off 130 Records."
        // const invalidPrimePartList =  ["N242376", "AKK15554", "AKK15554", "AKK15554", "AKK15554"]


        const valueStyleStart = {
            width: '2%',
            display: 'inline-block'
        };
        const valueStyleLeft = {
            width: '20%',
            display: 'inline-block',
            fontSize: '12px',
        };
        const valueStyleMiddle = {
            width: '3%',
            display: 'inline-block',
            fontSize: '12px',
            fontWeight:'bold'
        };
        const valueStyleRight = {
            width: '40%',
            display: 'inline-block',
            fontSize: '12px'
        };

        const valueStyleLeftListPP = {
            width: '75%',
            display: 'inline-block',
            fontSize: '12px'
        };
        const valueStyleLeftListContent = {
            width: '8%',
            display: 'inline-block',
            fontSize: '12px',
        };
        return (
            <section>
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter}/>
                <div className="massUpdate-page">
                    <div className="upload-label">
                        <h2>Batch Factory Data Upload</h2>
                    </div>
                    {/* <div className="sample-report">
                        <a title="Field having values can update only" href={CSVFile}
                           download="factory_data_extract.csv">Download Sample Report</a>
                    </div> */}
                    <div className="sample-report-analysis">
                    <a
                        title="Field having values can update only"
                        onClick={this.handleDownloadClick('factory_data_extract')}
                    >
                        Download Sample Report
                    </a>
                </div>
                    {/* <div className="sample-report">
                    <a
                        title="Field having values can update only"
                        onClick={this.handleDownloadClick('factory_data_extract')} >Download Sample Report </a>
                </div> */}
                    <FileUploadPanel
                        handleFileDrop={this.handleFileDrop}
                        handleRejectedFiles={this.handleRejectedFiles}
                        handleSubmitClick={this.handleSubmitClick}
                        handleCancleClick={this.handleCancleClick}
                        fileName={this.state.fileInfo.name}
                        refineWorklist={"refineWorklist"}
                        isRefineWorklist={this.state.isRefineWorklist}
                        handleCheckBoxClick={this.handleCheckBoxClick}

                    />
                </div>

                {/* <div>
                     {
                        (!_.isEmpty(this.state.uploadResp)) ?
                        <div style ={{ marginTop : '1%' ,backgroundColor :'#367c2b' ,color:'#fff' }}> 
                        
                        {
                            this.state.uploadResp.map((item)=>
                           <li><small> {item} </small> </li>
                            )} </div> : null

                    } 
                   
                </div> */}

                {/*<div style={containerStyle}>*/}
                {/*    <b>{uploadStatus} &#9989; </b>*/}
                {/*    {*/}
                {/*        Object.entries(responses).map( ([key, value]) =>*/}
                {/*            <small>*/}
                {/*            <ul>*/}
                {/*                <li style={valueStyleStart}>&#10004;</li>*/}
                {/*                <li style={valueStyleLeft}>{key}</li>*/}
                {/*                <li style={valueStyleMiddle}>&ndash;</li>*/}
                {/*                <li style={valueStyleRight}>{value} Records</li>*/}
                {/*            </ul>*/}
                {/*            </small>*/}
                {/*    )}*/}
                {/*    {*/}
                {/*        (!_.isEmpty(invalidPrimePartList)) ?*/}
                {/*            <div>*/}
                {/*                <hr></hr>*/}
                {/*                <ul>*/}
                {/*                    <li style={valueStyleStart}>&#9888;</li>*/}
                {/*                    <li style={valueStyleLeft}><b>INVALID PRIMEPART NUMBER</b></li>*/}
                {/*                    <li style={valueStyleMiddle}>&ndash;</li>*/}
                {/*                    <li style={valueStyleLeftListPP}>{invalidPrimePartList.length} Records</li>*/}
                {/*                    <li style={valueStyleStart}></li>*/}
                {/*                    {*/}
                {/*                        invalidPrimePartList.map((ppNumber) => (*/}
                {/*                            <li style={valueStyleLeftListContent}>&bull; {ppNumber}</li>*/}
                {/*                        ))}*/}
                {/*                </ul>*/}

                {/*            </div> : null*/}
                {/*    }*/}
                {/*</div>*/}


                {
                    (!_.isEmpty(this.state.uploadResp)) ?
                        <div style={containerStyle}>
                            <span role="img" aria-label="image">{this.state.uploadResp.status} &#9989; </span>
                            {
                                Object.entries(this.state.uploadResp.uploadStatisticsMap).map(([key, value]) =>
                                    <small>
                                        <ul>
                                            <li style={valueStyleStart}>&#10004;</li>
                                            <li style={valueStyleLeft}>{key}</li>
                                            <li style={valueStyleMiddle}>&ndash;</li>
                                            <li style={valueStyleRight}>{value} Records</li>
                                        </ul>
                                    </small>
                                )}

                            {
                                (!_.isEmpty(this.state.uploadResp.invalidPrimePartList)) ?
                                    <div>
                                        <hr></hr>
                                        <ul>
                                            <li style={valueStyleStart}>&#9888;</li>
                                            <li style={valueStyleLeft}><b>INVALID PRIMEPART NUMBER</b></li>
                                            <li style={valueStyleMiddle}>&ndash;</li>
                                            <li style={valueStyleLeftListPP}>
                                                {this.state.uploadResp.invalidPrimePartList.length} Records
                                            </li>
                                            <li style={valueStyleStart}></li>
                                            {
                                                this.state.uploadResp.invalidPrimePartList.map((ppNumber) => (
                                                    <li style={valueStyleLeftListContent}>&bull; {ppNumber}</li>
                                                ))}
                                        </ul>

                                    </div> : null
                            }

{
                                (!_.isEmpty(this.state.uploadResp.unAuthorizedFactoryList)) ?
                                    <div>
                                        <hr></hr>
                                        <ul>
                                            <li style={valueStyleStart}>&#9888;</li>
                                            <li style={valueStyleLeft}>UNAUTHORIZED FACTORY</li>
                                            <li style={valueStyleMiddle}>&ndash;</li>
                                            <li style={valueStyleLeftListPP}>
                                                {this.state.uploadResp.unAuthorizedFactoryList.length} Records
                                            </li>
                                            <li style={valueStyleStart}></li>
                                            {
                                                this.state.uploadResp.unAuthorizedFactoryList.map((factoryCode) => (
                                                    
                                                    <li style={valueStyleLeftListContent}>&#9733; {factoryCode}</li>
                                                ))}
                                        </ul>

                                    </div> : null
                            }

                        </div> : null
                }

            </section>
        );

    }

}

BatchFactoryDataUpload.displayName = 'BatchFactoryDataUpload';
BatchFactoryDataUpload.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
    busyCounter: showLoadingIndicator(state.application.busyCounter),
    factoryCode: state.application.factories.factoryCode,
    factories: state.application.factories.factories
});
const mapDispatchToProps = dispatch => ({
    increaseCounter: () => dispatch(busyCounter.increaseBusyCounter()),
    decreaseCounter: () => dispatch(busyCounter.decreaseBusyCounter()),
    createSuccessMessage: message => dispatch(createSuccessMessage(message)),
    createErrorMessage: message => dispatch(createErrorMessage(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BatchFactoryDataUpload);
